import React from 'react';

import { ContentBlockType } from '@rcdev/api-bff-parking';

import { ExpiredMainBlock } from '../../contentBlocks/ExpiredMainBlock/ExpiredMainBlock';
import { HtmlContent } from '../../contentBlocks/HtmlContent/HtmlContent';
import { ParkingPageBlock } from '../../contentBlocks/ParkingPageBlock/ParkingPageBlock';
import { TUpdatedContentBlock } from '../../utils/convertBlocksStructure';
import { LinesContentView } from '../LinesContentView';

export function renderBlocks(block: TUpdatedContentBlock) {
  switch (block.type) {
    case ContentBlockType.LinesContentView:
      return <LinesContentView key={block.position} {...block} />;
    case ContentBlockType.ExpiredMainBlock:
      return <ExpiredMainBlock key={block.position} {...block.data} />;
    case ContentBlockType.HtmlContent:
      return <HtmlContent key={block.position} {...block.data} />;
    case ContentBlockType.ParkingPageBlock:
      return <ParkingPageBlock key={block.position} {...block.data} />;
    default:
      return null;
  }
}
